var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeInsuranceDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#2EEFAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.218 35.6551C28.7359 32.2055 31.9963 29.1887 34.3528 26.4001L35.6195 24.8117C35.8806 24.4842 35.6474 23.9999 35.2285 23.9999L31.1332 24.0001C30.9582 24.0001 30.7959 24.0916 30.7053 24.2413L28.7405 27.4897C28.5809 27.7525 28.2929 27.9073 27.9857 27.8941C27.6797 27.8821 27.4049 27.7021 27.2681 27.4273L24.934 22.7105C24.7658 22.3705 24.2951 22.3343 24.0769 22.6446L23.3741 23.6437C23.2157 23.8669 22.9601 24.0001 22.6865 24.0001L17.6669 23.9999C16.3434 23.9999 15.861 24.1249 15.861 22.8001C15.861 21.4753 16.3434 21.5999 17.6669 21.5999L21.55 21.6001C21.7139 21.6001 21.8674 21.5198 21.9609 21.3851L24.0677 18.3481C24.2357 18.1057 24.5189 17.9701 24.8141 17.9893C25.1081 18.0085 25.3709 18.1825 25.5053 18.4453L27.8043 22.9391C27.9861 23.2944 28.4904 23.304 28.6856 22.9559L29.2049 22.0297C29.3537 21.7645 29.6333 21.6001 29.9369 21.6001H37.1328C37.3368 21.6001 37.5216 21.4766 37.5912 21.2849C37.9004 20.4338 38.0668 19.5925 38.0668 18.7549C38.0668 11.6614 29.1207 9.84531 25.3406 14.8353C25.1103 15.1394 24.6236 15.1393 24.3936 14.8349C20.5953 9.80665 11.667 11.6834 11.667 18.7549C11.667 23.7547 17.5932 28.8671 24.5148 35.6541C24.7098 35.8453 25.023 35.8463 25.218 35.6551Z",
    fill: "#C1FFE9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeInsuranceDetail);
export default __webpack_public_path__ + "static/media/life-insurance-detail.80bbd2ed.svg";
export { ForwardRef as ReactComponent };